import { styled } from '@/styles/stitches.config'

export const Ul = styled('ul', {
  pl: '$12',

  '& li': {
    mb: '$4',
  },
})
